import React from "react";
import { Col, Button, Row } from "reactstrap";
import styles from "./DesignCard.module.scss";
import DynamicButton from "../../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";

const DesignCard = ({ post }) => {
    const copyToClipboard = () => {
        navigator.clipboard.writeText(`${post.caption}\n\n${post.link}\n\n${post.hashtags.join(" ")}`);
        alert("Copied to clipboard!");
    };

    return (
        <div className={styles.designCardContainer}>
            <Row className={styles.designCardRow}>
                <Col xxl={4} className={styles.imgColumn}>
                    <img src={post.image} alt="Social Media Post" className={styles.designImage} />
                </Col>
                <Col xxl={8} className={styles.contentColumn}>
                    <div className={styles.textSection}>
                        <p>{post.caption}</p>
                        <a href={post.link} target="_blank" rel="noopener noreferrer">{post.link}</a>
                        <p className={styles.hashtags}>{post.hashtags.join(" ")}</p>
                    </div>
                    <Button color="link" className={styles.copyBtn} onClick={copyToClipboard}>Copy</Button>
                </Col>
            </Row>
            <DynamicButton theme="gray">Download</DynamicButton>
        </div>
    );
};

export default DesignCard;